import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { AutomationForm } from '#features/automations/automation-form.tsx'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/automations/new',
)({
  head: () => ({ meta: [{ title: 'New Automation' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  return <AutomationForm mode="create" />
}
